import { template as template_c073fc8d59b84708aa564c1c325829c2 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import CardError from '@cardstack/host/components/card-error';
import type { ErrorModel as IndexRouteErrorModel } from '@cardstack/host/routes/index';
interface Signature {
    Args: {
        model: IndexRouteErrorModel;
    };
}
const IndexErrorRouteComponent: TemplateOnlyComponent<Signature> = template_c073fc8d59b84708aa564c1c325829c2(`
  <CardError
    @type={{@model.loadType}}
    @message={{@model.message}}
    @operatorModeState={{@model.operatorModeState}}
  />
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default RouteTemplate(IndexErrorRouteComponent);
